import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { adminService } from '../../services/adminService';
import './Admin.css';

const AdminWalletDetail = () => {
  const { userId } = useParams();
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [adjustType, setAdjustType] = useState('credit');
  const [adjustAmount, setAdjustAmount] = useState('');
  const [adjustDesc, setAdjustDesc] = useState('');
  const [adjusting, setAdjusting] = useState(false);
  const [msg, setMsg] = useState(null);

  const fetchDetail = () => {
    setLoading(true);
    adminService.getWalletDetail(userId)
      .then(res => {
        setBalance(res.data.balance);
        setTransactions(res.data.transactions.data);
        setLastPage(res.data.transactions.last_page);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchDetail(); }, [userId, page]);

  const handleAdjust = async (e) => {
    e.preventDefault();
    setAdjusting(true);
    setMsg(null);
    try {
      const res = await adminService.adjustWallet(userId, {
        type: adjustType,
        amount: Number(adjustAmount),
        description: adjustDesc || undefined,
      });
      setBalance(res.data.balance);
      setMsg({ type: 'success', text: res.data.message });
      setAdjustAmount('');
      setAdjustDesc('');
      fetchDetail();
    } catch (err) {
      setMsg({ type: 'error', text: err.response?.data?.message || 'Adjustment failed.' });
    } finally {
      setAdjusting(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-page">
      <Link to="/admin/wallets" className="admin-back-btn">← Back to Wallets</Link>
      <h1>Wallet Detail</h1>

      <div className="admin-balance-card">
        <p className="balance-label">Current Balance</p>
        <p className="balance-value">🪙 {parseFloat(balance).toFixed(0)} coins</p>
      </div>

      {msg && <div className={`admin-msg ${msg.type}`}>{msg.text}</div>}

      <form className="admin-adjust-form" onSubmit={handleAdjust}>
        <div className="form-group">
          <label>Type</label>
          <select value={adjustType} onChange={e => setAdjustType(e.target.value)}>
            <option value="credit">Credit</option>
            <option value="debit">Debit</option>
          </select>
        </div>
        <div className="form-group">
          <label>Amount</label>
          <input type="number" min="1" value={adjustAmount} onChange={e => setAdjustAmount(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Description</label>
          <input value={adjustDesc} onChange={e => setAdjustDesc(e.target.value)} placeholder="Admin adjustment" />
        </div>
        <button type="submit" className="btn-primary" disabled={adjusting} style={{ marginTop: '20px' }}>
          {adjusting ? 'Processing...' : 'Adjust'}
        </button>
      </form>

      <div className="admin-table-wrapper" style={{ marginTop: 24 }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Balance After</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(t => (
              <tr key={t.id}>
                <td>{new Date(t.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                <td><span className={`status-badge ${t.type === 'credit' ? 'active' : 'deleted'}`}>{t.type}</span></td>
                <td>{parseFloat(t.amount).toFixed(0)} coins</td>
                <td>{t.description}</td>
                <td>{parseFloat(t.balance_after).toFixed(0)} coins</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminWalletDetail;
